import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { Cedente } from '../_models/cedente/cedente';

@Injectable({ providedIn: 'root' })
export class CedenteService {
  constructor(private http: HttpClient) { }

   getCedentesPorEmpresa(codEmpresa: number) {
    return this.http.get<Cedente[]>(`${environment.authorizedUrls.bsCobrancaUrl}/cedente/findByEmpresa/` + codEmpresa);
  }


}
